import { useParams } from 'react-router-dom';
import { usePreview } from 'shared/hooks/usePreview';

const sitemap = (dashboardId: string, currentJobOrderId?: string, previewToken?: string) => ({
  dashboard: `/${dashboardId}${previewToken ? `?previewToken=${previewToken}` : ''}`,
  jobOrderHistory: `/${dashboardId}/job-orders-history${previewToken ? `?previewToken=${previewToken}` : ''}`,
  jobOrder: (jobOrderId?: string) =>
    `/${dashboardId}/job-order/${jobOrderId ?? currentJobOrderId}${previewToken ? `?previewToken=${previewToken}` : ''}`,
  archivedJobOrder: (jobOrderId?: string) =>
    `/${dashboardId}/archived-job-order/${jobOrderId ?? currentJobOrderId}${previewToken ? `?previewToken=${previewToken}` : ''}`,
  blindsComparer: `/${dashboardId}/job-order/${currentJobOrderId}/blinds-comparison${previewToken ? `?previewToken=${previewToken}` : ''}`,
  archivedBlindsComparer: `/${dashboardId}/archived-job-order/${currentJobOrderId}/blinds-comparison${previewToken ? `?previewToken=${previewToken}` : ''}`,
  notFound: `/404${previewToken ? `?previewToken=${previewToken}` : ''}`,
  serviceUnavailable: `/503${previewToken ? `?previewToken=${previewToken}` : ''}`,
});

export type SitemapPath = keyof typeof sitemap;

export const useSitemap = () => {
  const { dashboardId, jobOrderId } = useParams();
  const { previewToken } = usePreview();

  if (!dashboardId) {
    throw new Error('dashboardId is missing');
  }

  return sitemap(dashboardId, jobOrderId, previewToken);
};
